<mat-sidenav-container
  class="mainWrapper"
  autosize
  autoFocus
  [ngClass]="{
    'sidebarNav-mini':
      options.sidenavCollapsed && options.navPos !== 'top' && !resView,
    'sidebarNav-horizontal': options.horizontal,
    cardBorder: options.cardBorder,
  }"
  [dir]="options.dir!"
>
  <!-- ============================================================== -->
  <!-- Vertical Sidebar -->
  <!-- ============================================================== -->
  @if (!options.horizontal) {
    <mat-sidenav
      #leftsidenav
      [mode]="isOver ? 'over' : 'side'"
      [opened]="
        options.navPos === 'side' &&
        options.sidenavOpened &&
        !isOver &&
        !resView
      "
      (openedChange)="onSidenavOpenedChange($event)"
      (closedStart)="onSidenavClosedStart()"
      class="sidebarNav"
    >
      <div class="flex-layout flex flex-col h-screen">
        <app-sidebar
          (toggleMobileNav)="sidenav.toggle()"
          [showToggle]="isOver"
        ></app-sidebar>
        <ng-scrollbar class="relative" style="height: 100%">
          <mat-nav-list class="sidebar-list">
            @for (item of navItems; track item) {
              <app-nav-item
                [item]="item"
                (notify)="sidenav.toggle()"
                class="top-parent"
              >
              </app-nav-item>
            }
          </mat-nav-list>
        </ng-scrollbar>
      </div>
    </mat-sidenav>
  }

  <!-- ============================================================== -->
  <!-- horizontal Sidebar -->
  <!-- ============================================================== -->
  @if (resView) {
    <mat-sidenav
      #leftsidenav
      [mode]="'over'"
      [opened]="options.sidenavOpened && !isTablet"
      (openedChange)="onSidenavOpenedChange($event)"
      (closedStart)="onSidenavClosedStart()"
      class="sidebarNav"
    >
      <app-sidebar> </app-sidebar>
      <ng-scrollbar class="relative" style="height: 100%">
        <mat-nav-list class="sidebar-list">
          @for (item of navItems; track item) {
            <app-nav-item [item]="item" (notify)="sidenav.toggle()">
            </app-nav-item>
          }
        </mat-nav-list>
      </ng-scrollbar>
    </mat-sidenav>
  }

  <!-- ============================================================== -->
  <!-- Main Content -->
  <!-- ============================================================== -->
  <mat-sidenav-content class="contentWrapper" #content>
    <!-- ============================================================== -->
    <!-- VerticalHeader -->
    <!-- ============================================================== -->
    @if (!options.horizontal || resView) {
      <app-header
        [showToggle]="!isOver"
        (toggleCollapsed)="toggleCollapsed()"
        (toggleMobileNav)="sidenav.toggle()"
        (toggleShoppingCartNav)="filterNavRight.toggle()"
        (optionsChange)="receiveOptions($event)"
      ></app-header>
    } @else {
      <!-- horizontal header -->
      <app-horizontal-header
        (toggleMobileNav)="sidenav.toggle()"
        (toggleShoppingCartNav)="filterNavRight.toggle()"
        (optionsChange)="receiveOptions($event)"
      ></app-horizontal-header>
    }
    @if (options.horizontal) {
      <app-horizontal-sidebar></app-horizontal-sidebar>
    }
    <div class="body-wrapper">
      <main
        class="pageWrapper"
        [ngClass]="{
          maxWidth: options.boxed,
        }"
      >
        <app-breadcrumb></app-breadcrumb>
        <!-- ============================================================== -->
        <!-- Outlet -->
        <!-- ============================================================== -->
        <router-outlet></router-outlet>
        <div class="fixed bottom-7 right-7 rtl:right-auto rtl:left-7 z-10">
          <button
            mat-fab
            class="bg-primary text-white!"
            (click)="customizerRight.toggle()"
          >
            <mat-icon>settings</mat-icon>
          </button>
        </div>
      </main>
    </div>
    <app-footer></app-footer>
  </mat-sidenav-content>

  <mat-sidenav
    #customizerRight
    mode="over"
    position="end"
    class="customizerNav"
  >
    <div
      class="px-4 py-5 flex! items-center justify-between border-b border-border"
    >
      <h3 class="text-xl font-semibold">Settings</h3>

      <a
        mat-icon-button
        (click)="customizerRight.toggle()"
        class="flex justify-center"
      >
        <mat-icon>close</mat-icon>
      </a>
    </div>

    <app-customizer (optionsChange)="receiveOptions($event)"></app-customizer>
  </mat-sidenav>
</mat-sidenav-container>

<mat-drawer
  #filterNavRight
  mode="over"
  position="end"
  class="shoppingcartNav border-l border-border"
>
  <div class="px-4 py-4 flex items-center justify-between">
    <h3 class="text-lg">Shopping Cart</h3>
    <button
      mat-icon-button
      (click)="filterNavRight.toggle()"
      class="flex justify-center"
    >
      <i
        class="iconify text-xl flex"
        data-icon="solar:close-circle-line-duotone"
      ></i>
    </button>
  </div>
  <div class="p-4">
    <div class="flex flex-col items-center gap-6">
      <img
        src="/assets/images/backgrounds/empty-shopping-cart.svg"
        class="img-fluid"
        width="200"
        alt="empty-shopping-cart"
      />
      <h5 class="text-lg">Cart is Empty</h5>
      <a matButton="filled" href="javascript:void(0)">Go back to Shopping</a>
    </div>
  </div>
</mat-drawer>
